import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../../Image';
import { shuffleAnswers } from '../../Answers/utils';
import { RANKING_QUESTION_LABELS_SORT_ASCENDING } from '../../../constants';

export default function Ranking({ question = {}, getText }) {
  const { high, low, sort } = question.rankingOptions || {};
  const [selections, setSelections] = useState([]);

  const answers = useMemo(() => shuffleAnswers(question), [question]);
  const handleTap = useCallback(
    (e) => {
      const answer = e.target;
      const answerEl = $(answer);
      const target = answerEl.attr('data-target');
      const selectedVal = answerEl.attr('data-answer');

      let newSelections = [...selections];
      // removes already selected values when pressing same value twice
      newSelections = newSelections.filter(
        (selection) =>
          selection.answer !== selectedVal && selection.target !== target,
      );

      newSelections.push({
        target,
        answer: selectedVal,
      });

      setSelections(newSelections);
      activateRanking(newSelections);
    },
    [selections, activateRanking],
  );

  const activateRanking = useCallback((ranks) => {
    $('.ranking__answer-btn').removeClass(
      'ranking__answer-btn--disabled ranking__answer-btn--selected',
    );
    // we need to reset both values since jquery.data keeps it's own object
    $('.ranking').removeAttr('data-selected-rank');
    $('.ranking').data('selected-rank', '');
    ranks.forEach((rank) => {
      const row = $(`.ranking[data-id=${rank.target}]`);
      row.attr('data-selected-rank', rank.answer);
      // disable the user ranking value for other answers
      $(`[data-answer=${rank.answer}]`).addClass(
        'ranking__answer-btn--disabled',
      );
      // disable the other rank values for this answer
      $(`.ranking__answer-btn[data-target=${rank.target}]`).addClass(
        'ranking__answer-btn--disabled',
      );
      // highlight the selected value for this answer
      $(`[data-target=${rank.target}][data-answer=
          ${rank.answer}]`)
        .removeClass('ranking__answer-btn--disabled')
        .addClass('ranking__answer-btn--selected');
    });
  }, []);

  // mobile may receive custom labels for high and low
  let highText = high || getText('high');
  let lowText = low || getText('low');
  // also may receive ascending or descending order
  // in this case we swap just the labels
  if (sort === RANKING_QUESTION_LABELS_SORT_ASCENDING) {
    [highText, lowText] = [lowText, highText];
  }

  return (
    <div className="ranking-wrapper">
      {answers.map((answer) => (
        <div
          className={classNames('ranking answerRanking', {
            'carry-forward-inline': answer.isCarriedForward,
          })}
          data-id={answer.id}
          key={`row-${answer.id}`}
        >
          <Image
            row={{
              imageUrl: answer.image_url,
              optimizedImageUrl: answer.optimized_image_url,
            }}
          />
          <div
            className="ranking__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: answer.body }}
          />
          <div className="ranking__answers">
            <div className="ranking__answers-wrapper">
              {answers.map((_, index) => (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={`selection-${answer.id}-${index}`}
                  className="ranking__answer-btn"
                  data-answer={index + 1}
                  data-target={answer.id}
                  onClick={handleTap}
                >
                  {index + 1}
                </div>
              ))}
            </div>
            <div className="ranking__answers__hints">
              <div className="ranking__answers-high">{highText}</div>
              <div className="ranking__answers-low">{lowText}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

Ranking.propTypes = {
  question: PropTypes.object,
  getText: PropTypes.func.isRequired,
};
